<template>
  <div class="app" v-if="$store.state.isLogged">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <!--<img class="navbar-brand-full" src="img/brand/logo.svg" width="89" height="25" alt="">
        <img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="">-->
        <h4 class="mx-4">SmartIndexer</h4>
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt/>
        <b-nav-item class="d-md-down-none" @click="onLogout">
          <i class="icon-logout"></i>
        </b-nav-item>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav v-if="refresh" :navItems="nav"></SidebarNav>
        <SidebarNav :navItems="admin" v-if="$store.state.isAdmin"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <span class="ml-1">&copy; 2019 SmartIndexer.net</span>
      </div>
      <div class="ml-auto">
        
      </div>
    </TheFooter>
  </div>
</template>

<script>
import Vue from 'vue'

import nav from '@/_nav'
import admin from '@/_admin'

import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'

import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    DefaultHeaderDropdownAccnt
  },
  data () {
    return {
      refresh: true,
      nav: nav.items,
      admin: admin.items
    }
  },
  methods: {
    onLogout () {
      Vue.axios({
        method: 'POST',
        url: '/user/logout',
        mode: 'no-cors',
        withCredentials: true,
        credentials: 'same-origin'
      }).then(response => {
        
      }).catch(() => {
        
      })

      this.$router.push({name: 'Login'})
      this.$store.state.isLogged = false
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label)
    }
  },
  beforeMount () {
    const that = this

    this.nav = this.nav.map(el => {
      el.name = that.$translate.text(el.original)

      return el
    })
  }
}
</script>
